import { useCallback } from 'react';

import { getAddresses } from 'common/api/crm/family/address';
import { useApi } from 'common/modules/async-actions/useApi';

export const useAddresses = () => {
    const [doGetAddresses, addressesAsyncState, addressesResult] = useApi(getAddresses);
    const addresses = (addressesResult && addressesResult.data) || null;
    const refreshAddresses = useCallback(async () => {
        const response = await doGetAddresses();

        if (response.error) {
            return false;
        }

        return true;
    }, [doGetAddresses]);

    return {
        addresses,
        asyncState: addressesAsyncState,
        refreshAddresses,
    };
};
